export const sortFormOptionsAlphabetical = (
  a: FormDropDownOption,
  b: FormDropDownOption,
) => (a.label < b.label ? -1 : Number(a.label > b.label));
